export default "__VITE_ASSET__d983960f__"